import { child_icon_3 } from './icons'

export function getValidationMessagesModalContent(messages) {
    return {
        title: 'An error occured',
        buttonText: 'OK',
        body:
            <ul className="list-group">
                {messages.map((error, index) => <li key={index} className="list-group-item" style={{ fontSize: '16px' }}>{error}</li>)}
            </ul>
    };
}

export function getBase64(source) {
    if (source != null) {
        return `data:image/png;base64,${source}`;
    } else {
        return '';
    }
}

export function currencyFormat(num) {
    if (!num) {
        return '';
    } else {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
}

export function getCategoryIcon(category) {
    switch (category) {
        case "Adult":
            return <i className="bi bi-person"></i>;
            break;
        case "Youth":
            return child_icon_3;
            break;
    }
}
export function updateStepData(stepData, updatedProp) {
    if (!stepData) stepData = {};
    for (const key in updatedProp) {
        stepData[key] = updatedProp[key];
    }
    return stepData;
}